export const delay = (ms: number) =>
  new Promise<void>(resolve => setTimeout(resolve, process.env.NODE_ENV === 'development' ? 0 : ms));
